<template>
  <div>
    <v-card rounded class="pa-4">
      <v-row class="ma-0">
        <v-col cols="12" lg="8" md="8" sm="6" xs="12">
          <v-card-title>Papers</v-card-title>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="6" xs="12">
          <v-text-field
            id="trackpapers-search-input"
            v-model="search"
            outlined
            label="Search..."
            :append-icon="icon.mdiMagnify"
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="px-4">
        <v-data-table
          :headers="headers"
          :items="filterPapers"
          :search="search"
          :loading="loading"
          loading-text="Loading papers... Wait a moment."
        >
          <template v-slot:item.status="{ item }">
            <div
              :style="`color: ${getStatusColor(
                item.state.status
              )}; font-weight: 400`"
            >
              {{ item.state.status }}
            </div>
          </template>
          <template v-slot:item.reviews="{ item }">
            <v-btn
              :id="'trackpapers-review-' + item.id"
              icon
              @click="
                reviewsDialog = true;
                selectedPaper = item;
              "
            >
              <v-icon color="black"> {{ icon.mdiAccountGroup }}</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="reviewsDialog" max-width="70%">
      <manage-reviews
        v-on:close="reviewsDialog = false"
        :paper="selectedPaper"
      />
    </v-dialog>
  </div>
</template>

<script>
import paperStatus from "@/helpers/paperStatus.js";
import ManageReviews from "@/components/molecules/paper/ManageReviews.vue";
import { mdiMagnify, mdiAccountGroup } from "@mdi/js";

export default {
  props: ["papers"],
  components: {
    ManageReviews,
  },
  data() {
    return {
      icon: {
        mdiMagnify,
        mdiAccountGroup,
      },
      search: "",
      reviewsDialog: false,
      selectedPaper: {},
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: "Last Update",
          value: "lastUpdate",
          sortable: true,
          align: "end",
        },
        { text: "Status", value: "status", sortable: true, align: "end" },
        { text: "Reviews", value: "reviews", align: "end" },
      ],
    };
  },
  computed: {
    filterPapers() {
      return this.papers.filter((p) => {
        return p.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    loading() {
      if (this.$store.getters.papers == null) return true;
      return false;
    },
  },
  methods: {
    getStatusColor(status) {
      return paperStatus.getStatusColor(status);
    },
  },
};
</script>